export default __webpack_public_path__ + "static/media/cnaps-school-logo.ff60d2ff.svg";